import { render, staticRenderFns } from "./PlaylistCard.vue?vue&type=template&id=83755504&"
import script from "./PlaylistCard.vue?vue&type=script&lang=js&"
export * from "./PlaylistCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports